import { FC, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';

import { selectProfileRedirectionPath } from '../../../accounts/selectors/profile-redirection-path.selector.ts';
import { useAppSelector } from '../../../main/hooks/use-app-selector.ts';
import { selectAppRedirectionItemTarget } from '../../../main/selectors/app-redirection-item-target.selector.ts';

import { AccountScreenProtector } from './account-screen-protector.tsx';

interface Props {
  children: ReactNode;
}

const ProfileScreenProtectorRedirections: FC<Props> = ({ children }) => {
  const location = useLocation();

  const redirectionPath = useAppSelector(selectProfileRedirectionPath);
  const redirectionItemTarget = useAppSelector((state) =>
    selectAppRedirectionItemTarget(state, { currentPath: location.pathname })
  );

  if (redirectionPath) {
    return <Navigate to={redirectionPath} />;
  }

  if (redirectionItemTarget) {
    return <Navigate to={redirectionItemTarget.path} replace={true} />;
  }

  return children;
};

export const ProfileScreenProtector: FC<Props> = ({ children }) => {
  return (
    <AccountScreenProtector>
      <ProfileScreenProtectorRedirections>{children}</ProfileScreenProtectorRedirections>
    </AccountScreenProtector>
  );
};
